import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '../../app.config';
import { TokenService } from './token.service';

import { getAuthToken } from '../auth.interceptor';

export interface LoginAttempt {
    policyNumber: string;
    loanNumber: string;
    zipCode: string;
    insuredType: string;
    firstName: string;
    lastName: string;
    trustName: string;
}

export interface IrisTaskPayload {
    policyNumber: string;
    email: string;
    phone: string;
    description: string;
    firstName?: string;
    lastName?: string;
    trustName?: string;
    loanNumber?: string;
    zipCode?: string;
    insuredType?: string;
}

@Injectable({
    providedIn: 'root',
})

export class CreateTaskIrisService {
    private readonly TIMEOUT = 60000;
    private readonly headers: HttpHeaders;
    

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG) private config: AppConfig,
        private tokenService: TokenService
    ) {}

    createTask(data: IrisTaskPayload, token?: string): Observable<any> {
        
        const authToken = token || this.tokenService.getToken() || getAuthToken();

        const headers = new HttpHeaders({
            'x-api-key': this.config.irisApiKey,
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        });


        


        

        const payload = {
    domain: 'policy',
    classification: 'Third Party Authentication Error',
    subject: `Third Party Authentication Error ${data.policyNumber}`,
    entityType: 'policy',
    entityId: `${data.policyNumber}`,
    priority: 'high',
    assignedGroup: 'CSR',
    requestDescription: ` ${data.description} `,
    metadata: {
    firstName: data.firstName ?? '',
    lastName: data.lastName ?? '',
    insuredType: data.insuredType ?? '',
    phone: data.phone ?? '',
    zipCode: data.zipCode ?? '',
    loanNumber: data.loanNumber ?? '',
    trustName: data.trustName ?? '',
    email: data.email ?? '',
},


};
  


        return this.http.post(this.config.irisTaskURL, payload, { headers }).pipe(
            timeout(this.TIMEOUT),
            catchError(error => throwError(() => error))
        );
    }
}
